export default __webpack_public_path__ + "static/media/marquee2.544b5bf8.png";